import { apiClient } from '@/plugins/api'

export default {
  getUser() {
    return apiClient.get('/admin/user')
  }
}
